// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SECO","colMin":"styles_colMin__3f_r3"};